module.exports = __webpack_public_path__ + "static/media/canari_logo_egg.7e25915a.png";